const TOKEN_KEY = 'authToken';

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);

export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const isAuthenticated = () => Boolean(getToken());

export const redirectToLogin = () => {
  clearToken();
  if (window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
};
